import { appendUrlParams } from "utils/urlUtils";
import {
  PAGE_BUILDER_SOURCES,
  sales_page_detail_keys,
} from "../constants/SalesPages.constants";
import { getCreatorHostsiteURL } from "features/Account/utils/getCreatorPageDetails";
import {
  SALES_PAGE_URL_NEW_SLUG,
  SALES_PAGE_URL_SLUG,
} from "ui/pages/SalesPages/constants";

export const getSalePagePathPrefix = ({ salePageDetail = {} }) => {
  const pageSourceFromMetadata =
    salePageDetail?.[sales_page_detail_keys.metadata]?.[
      sales_page_detail_keys.page_builder_source
    ];
  const pageBuilderSource =
    pageSourceFromMetadata !== undefined
      ? pageSourceFromMetadata
      : salePageDetail?.[sales_page_detail_keys.page_builder_source];

  if (
    pageBuilderSource === PAGE_BUILDER_SOURCES.ai_builder ||
    pageBuilderSource === PAGE_BUILDER_SOURCES.grapes_js
  ) {
    return SALES_PAGE_URL_NEW_SLUG;
  }
  return SALES_PAGE_URL_SLUG;
};

export const getSalePagePathname = ({ salePageDetail = {} }) => {
  const path = getSalePagePathPrefix({ salePageDetail });

  return appendUrlParams(
    `/${path}/${
      salePageDetail[sales_page_detail_keys.url_slug] ||
      salePageDetail[sales_page_detail_keys.uuid]
    }`
  );
};

export const getSalePageUrl = ({ salePageDetail = {}, params = {} }) => {
  const url = appendUrlParams(
    `${getCreatorHostsiteURL().url}${getSalePagePathname({ salePageDetail })}`,
    {
      ...(params.preview ? { preview: true } : {}),
      ...(params.templateSlug ? { template: params.templateSlug } : {}),
      ...(params.ts ? { ts: params.ts } : {}),

      // @dev : This is done if we need to disable the animations for the
      // CT Sale Page Builder Preview Iframe
      ...(params.disableAnimation ? { disable_animation: true } : {}),
    }
  );

  return url;
};
